module.exports = __webpack_public_path__ + "img/pwa-install-popup-bg.48176ded.png";